import React, { useCallback, useEffect, useState } from "react";
import "./AdvertGallery.css";

// Bağımsız (kütüphanesiz) ilan galerisi: ana görsel + küçük resim şeridi +
// sahibinden benzeri tam ekran lightbox (büyüt/küçült). `photos` API'nin
// detayda döndürdüğü tam URL dizisidir; tek görselli ilanlarda yalnızca ana
// görsel gösterilir (şerit/ok render edilmez), ancak lightbox yine açılır.
function AdvertGallery({ photos, alt }) {
  const list = Array.isArray(photos) ? photos.filter(Boolean) : [];
  const count = list.length;
  const [active, setActive] = useState(0);
  const [lightbox, setLightbox] = useState(false);

  useEffect(() => {
    setActive(0);
  }, [photos]);

  const go = useCallback(
    (dir) => {
      if (count < 1) return;
      setActive((i) => (i + dir + count) % count);
    },
    [count]
  );

  // Lightbox açıkken klavye (Esc kapat, ← → gezin) ve arka plan kaydırma kilidi.
  useEffect(() => {
    if (!lightbox) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") setLightbox(false);
      else if (e.key === "ArrowLeft") go(-1);
      else if (e.key === "ArrowRight") go(1);
    };
    window.addEventListener("keydown", onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [lightbox, go]);

  if (!count) return null;

  const safeActive = Math.min(active, count - 1);
  const multi = count > 1;

  return (
    <div className="advert-gallery">
      <div className="advert-gallery__main">
        <img
          src={list[safeActive]}
          alt={alt || ""}
          className="img-responsive advert-detail-image"
          onClick={() => setLightbox(true)}
        />
        <button
          type="button"
          className="advert-gallery__zoom"
          onClick={() => setLightbox(true)}
          aria-label="Fotoğrafı büyüt"
        >
          <i className="ti-fullscreen" />
        </button>
        {multi && (
          <>
            <button
              type="button"
              className="advert-gallery__nav advert-gallery__nav--prev"
              onClick={() => go(-1)}
              aria-label="Önceki fotoğraf"
            >
              <i className="ti-angle-left" />
            </button>
            <button
              type="button"
              className="advert-gallery__nav advert-gallery__nav--next"
              onClick={() => go(1)}
              aria-label="Sonraki fotoğraf"
            >
              <i className="ti-angle-right" />
            </button>
            <span className="advert-gallery__counter">
              {safeActive + 1} / {count}
            </span>
          </>
        )}
      </div>

      {multi && (
        <div className="advert-gallery__thumbs">
          {list.map((src, idx) => (
            <button
              type="button"
              key={src + idx}
              className={`advert-gallery__thumb${
                idx === safeActive ? " is-active" : ""
              }`}
              onClick={() => setActive(idx)}
            >
              <img src={src} alt="" />
            </button>
          ))}
        </div>
      )}

      {lightbox && (
        <div
          className="advert-lightbox"
          onClick={() => setLightbox(false)}
          role="dialog"
          aria-modal="true"
        >
          <button
            type="button"
            className="advert-lightbox__close"
            onClick={() => setLightbox(false)}
            aria-label="Kapat"
          >
            <i className="ti-close" />
          </button>

          <img
            src={list[safeActive]}
            alt={alt || ""}
            className="advert-lightbox__img"
            onClick={(e) => e.stopPropagation()}
          />

          {multi && (
            <>
              <button
                type="button"
                className="advert-lightbox__nav advert-lightbox__nav--prev"
                onClick={(e) => {
                  e.stopPropagation();
                  go(-1);
                }}
                aria-label="Önceki fotoğraf"
              >
                <i className="ti-angle-left" />
              </button>
              <button
                type="button"
                className="advert-lightbox__nav advert-lightbox__nav--next"
                onClick={(e) => {
                  e.stopPropagation();
                  go(1);
                }}
                aria-label="Sonraki fotoğraf"
              >
                <i className="ti-angle-right" />
              </button>
              <span className="advert-lightbox__counter">
                {safeActive + 1} / {count}
              </span>
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default AdvertGallery;
